module.exports = __webpack_public_path__ + "img/2.57cf8ce4.jpg";